import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Statistic } from 'antd';
import { history } from 'ice';
import {
  CodepenOutlined,
  CodeSandboxOutlined,
  SolutionOutlined,
  UsergroupAddOutlined,
} from '@ant-design/icons';

import styles from './index.module.scss';
import client from '../../../../lib/feathers';
import moment from 'moment';
// import { store as appStore } from 'ice';

const Home = () => {
  // const [accountPageSetting, userDispatchers] = appStore.useModel('user');
  const [dateTime, setDateTime] = useState(new Date());
  const [usersName, setUsersName] = useState('');
  const [total, setTotal] = useState({
    postalRegistration: 0,
    deposit: 0,
  });
  const postalRegistration = client.service('postalRegistration');
  const deposit = client.service('deposit');
  const visitorAppointmentRegistration = client.service(
    'visitorAppointmentRegistration'
  );
  const communityData = client.service('communityData');
  useEffect(() => {
    const id = setInterval(() => setDateTime(new Date()), 1000);
    return () => {
      clearInterval(id);
    };
  }, []);
  const file = ['/ezcon/doc/EZ社區後台 v1.pdf'];

  useEffect(() => {
    try {
      client
        .reAuthenticate()
        .then((data) => {
          //console.log('==relogin ok', data.user);
          setUsersName(data.user.name);
        })
        .catch((err) => {
          console.log('==find user name', err);
        });
    } catch (err) {
      console.log('上未連接server:', err);
    }
  }, []);
  useEffect(() => {
    (async () => {
      const postalRes = await postalRegistration.find({
        query: { status: '未領取' },
      });
      const depRes = await deposit.find({
        query: { status: '未領取' },
      });
      const visitorRes = await visitorAppointmentRegistration.find({});
      setTotal({
        postalRegistration: postalRes.data.length,
        deposit: depRes.data.length,
        visitorReview: visitorRes.data.filter(
          (item) => item.visitorsStatus === '審核中'
        ).length,
        visitorTotal: visitorRes.data.filter(
          (item) =>
            parseInt(item.reservationTimeStart, 10) >=
              moment().startOf('day').valueOf() &&
            parseInt(item.reservationTimeStart, 10) <=
              moment().endOf('day').valueOf() &&
            item.visitorsStatus !== '審核中'
        ).length,
        visitorIn: visitorRes.data.filter(
          (item) =>
            item.reservationTimeStart >= moment().startOf('day').valueOf() &&
            item.reservationTimeStart <= moment().endOf('day').valueOf() &&
            (item.visitorsStatus === '已入場' ||
              item.visitorsStatus === '已離場')
        ).length,
        visitorOut: visitorRes.data.filter(
          (item) =>
            item.reservationTimeStart >= moment().startOf('day').valueOf() &&
            item.reservationTimeStart <= moment().endOf('day').valueOf() &&
            item.visitorsStatus === '已離場'
        ).length,
      });
    })();
  }, [postalRegistration, deposit, visitorAppointmentRegistration]);

  return (
    <div className={styles.homeContainer}>
      <div className={styles.homeUserName}>
        <div>
          {usersName
            ? `${usersName}您好`
            : '尚未設定用戶名!請至個人設置=>暱稱修改'}
          <a
            className={styles.homeDownload}
            download={file}
            rel="noreferrer"
            href={file}
          >
            {file === '' ? '' : '下載教學手冊'}
          </a>
        </div>
        <div>
          {`${dateTime.toLocaleDateString()} ${moment(dateTime).format(
            'dddd'
          )} ${dateTime.toLocaleTimeString()}`}
        </div>
      </div>
      {/* <div className={styles.homeDownloadBox}>
        <div className={styles.homeDownloadText}>
          提供後台教學手冊，可供下載。
        </div>
        <a
          className={styles.homeDownload}
          download={file}
          rel="noreferrer"
          href={file}
        >
          {file === '' ? '' : '下載'}
        </a>
      </div>
        {/* <Col span={24}>
          <Card bordered={false}>
            <div className={styles.homeUserName}>
              <div>
                {usersName
                  ? `歡迎${usersName}回來`
                  : '尚未設定用戶名!請至個人設置=>暱稱修改'}
                <a
                  className={styles.homeDownload}
                  download={file}
                  rel="noreferrer"
                  href={file}
                >
                  {file === '' ? '' : '下載教學手冊'}
                </a>
              </div>
              <div>
                {`${dateTime.toLocaleDateString()} ${moment(dateTime).format(
                  'dddd'
                )} ${dateTime.toLocaleTimeString()}`}
              </div>
            </div>
          </Card>
        </Col> */}
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Card
            bordered={false}
            onClick={() => {
              history.push('/ezpro/postal/postalReceive');
            }}
          >
            <Statistic
              title="未領取郵件包裹數量"
              value={total.postalRegistration}
              valueStyle={{ color: '#cf1322' }}
              suffix="件"
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card
            bordered={false}
            onClick={() => history.push('/ezpro/deposit/depositReceive')}
          >
            <Statistic
              title="未領取寄物數量"
              value={total.deposit}
              valueStyle={{ color: '#cf1322' }}
              suffix="件"
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card
            bordered={false}
            onClick={() =>
              history.push(
                '/ezpro/visitorAccess/visitorAccessAppointmentRegistration'
              )
            }
          >
            <Statistic
              title="待審核訪客數量"
              value={total.visitorReview}
              valueStyle={{ color: '#cf1322' }}
              suffix="人"
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card
            bordered={false}
            onClick={() =>
              history.push(
                '/ezpro/visitorAccess/visitorAccessAppointmentRegistration'
              )
            }
          >
            <Statistic
              title="今日預計來訪人數"
              value={total.visitorTotal}
              valueStyle={{ color: '#3f8600' }}
              suffix="人"
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card
            bordered={false}
            onClick={() =>
              history.push(
                '/ezpro/visitorAccess/visitorAccessAppointmentRegistration'
              )
            }
          >
            <Statistic
              title="今日實際來訪人數"
              value={total.visitorIn}
              valueStyle={{ color: '#3f8600' }}
              suffix="人"
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card
            bordered={false}
            onClick={() =>
              history.push(
                '/ezpro/visitorAccess/visitorAccessAppointmentRegistration'
              )
            }
          >
            <Statistic
              title="今日訪客離場人數"
              value={total.visitorOut}
              valueStyle={{ color: '#cf1322' }}
              suffix="人"
            />
          </Card>
        </Col>
        <Col span={24}>
          <Card bordered={false}>
            <Row gutter={[16, 16]}>
              <Col span={24}>快速前往</Col>
              <Col span={6}>
                <Card
                  className={styles.CardButton}
                  onClick={() =>
                    history.push('/ezpro/postal/postalRegistration')
                  }
                >
                  <div>
                    <CodepenOutlined
                      style={{
                        fontSize: '5vw',
                        color: '#08c',
                        marginBottom: 10,
                      }}
                    />
                  </div>
                  <div>包裹登記</div>
                </Card>
              </Col>
              <Col span={6}>
                <Card
                  className={styles.CardButton}
                  onClick={() =>
                    history.push('/ezpro/deposit/depositRegistration')
                  }
                >
                  <div>
                    <CodeSandboxOutlined
                      style={{
                        fontSize: '5vw',
                        color: '#08c',
                        marginBottom: 10,
                      }}
                    />
                  </div>
                  <div>寄物登記</div>
                </Card>
              </Col>
              <Col span={6}>
                <Card
                  className={styles.CardButton}
                  onClick={() =>
                    history.push(
                      '/ezpro/visitorAccess/visitorAccessAppointmentRegistration'
                    )
                  }
                >
                  <div>
                    <SolutionOutlined
                      style={{
                        fontSize: '5vw',
                        color: '#08c',
                        marginBottom: 10,
                      }}
                    />
                  </div>
                  <div>訪客登記</div>
                </Card>
              </Col>
              <Col span={6}>
                <Card
                  className={styles.CardButton}
                  onClick={() => history.push('/ezpro/account/accountList')}
                >
                  <div>
                    <UsergroupAddOutlined
                      style={{
                        fontSize: '5vw',
                        color: '#08c',
                        marginBottom: 10,
                      }}
                    />
                  </div>
                  <div>住戶磁扣開通</div>
                </Card>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      {/* <div>
        <h1>切換至App<span> <SolutionLink /></span></h1> 
      </div>
      <div>
        <h1>這是首頁 歡迎!!<span> <HomeOutlined /></span></h1> 
      </div> */}
      {/* {accountPageSetting.data&&accountPageSetting.data.length>0?accountPageSetting.data.map((x=>
      <div key={x._id}>{x.auth}</div>)):null} */}
    </div>
  );
};

export default Home;
